import differenceBy from "lodash/differenceBy"

export const hasMoreThan1Element = (array: Array<any>) => hasMoreThenNElements(array, 1)

export const hasMoreThenNElements = (array: Array<any> = [], n: number) => array.length > n

export const diff = <T>(array1: Array<T>, array2: Array<T>, sortKey: (item: T) => string) => {
    // Items removed from array1 (exist in array2 but not in array1)
    const removed = differenceBy(array2, array1, sortKey)

    // Items only new in array1 (exist in array1 but not in array2)
    const added = differenceBy(array1, array2, sortKey)

    return {
        removed,
        added,
        hasChanges: removed.length > 0 || added.length > 0,
    }
}
